<template>
  <p>
    Diseña e implementa IVR para enviar al finalizar la gestión de tus usuarios.
    <a :href="isAutomatic ? DOCS_URL : DOCS_URL2" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
  </p>

  <a-form class="filters__form" layout="vertical" :model="formState">
    <a-form-item name="name">
      <a-input
        v-model:value="formState.name"
        placeholder="Buscar"
        class="filters__input__large"
        @change="fetchBotsList"
      >
        <template #prefix>
          <SearchOutlined />
        </template>
      </a-input>
    </a-form-item>

    <a-form-item>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.status"
        class="filters__input"
        placeholder="Seleccionar estado"
        @change="fetchBotsList"
      >
        <a-select-option :key="''"> Todos los estados </a-select-option>
        <a-select-option :key="BotStatus.Active"> Activos </a-select-option>
        <a-select-option :key="BotStatus.Inactive"> Inactivos </a-select-option>
      </a-select>
    </a-form-item>
  </a-form>

  <CustomScrollbar height="calc(100% - 80px)" style="margin: 0">
    <BotsList :botsList="botsList" :loading="loading" @update="fetchBotsList" />
  </CustomScrollbar>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { useRoute } from "vue-router";

import { BotStatus, BotType } from "@/app/ivr/bot/utils/enums";
import { Bot, Filters } from "@/@types/ivr";
import { botServices } from "@/app/ivr/bot/services/BotServices";

import BotsList from "@/app/ivr/bot/components/lists/BotsList.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/flujos/modulo-ivr-operador-automático/`;
const DOCS_URL2 = `${import.meta.env.VITE_WEB_DOC}/ivr-encuesta-de-satisfacción/`;

const route = useRoute();

const isAutomatic = route.path.includes("ivr-automatic");

const formState = reactive<Filters>({
  name: "",
  channel: "",
  status: "",
  type: isAutomatic ? BotType.Automatic : BotType.Survey,
});

const loading = ref(false);
const botsList = ref<Bot[]>([]);

const fetchBotsList = async () => {
  try {
    loading.value = true;
    botsList.value = await botServices.getList(formState);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await fetchBotsList();
});
</script>

<style scoped lang="sass">
p
  margin: 0

.ant-form-item
  margin: 0

.filters
  &__form
    display: flex
    gap: 8px
    margin: 20px 0

  &__input
    min-width: 180px

    &__large
      min-width: 260px
</style>
